module.exports = __webpack_public_path__ + "static/media/A18040103_10003_4.8ec9692c.jpg";